import { Component, computed, inject, input } from '@angular/core';
import { _, TranslatePipe } from '@ngx-translate/core';
import { ChartComponent } from '@sb/ui/chart';
import { DashboardWidgetModule } from '@sb/ui/dashboard-widget/dashboard-widget.module';

import { GraphSize, TurnoverGraphDataType } from '../../enums';
import { ChartTurnoverResponse } from '../../models';
import { ChartHelperService, ChartLineChart } from '../../services/chart-helper.service';

@Component({
  selector: 'app-turnover-graph',
  templateUrl: './turnover-graph.component.html',
  imports: [ChartComponent, TranslatePipe, DashboardWidgetModule],
})
export class TurnoverGraphComponent {
  private chartHelper = inject(ChartHelperService);

  graphData = input.required<ChartTurnoverResponse>();
  isLoading = input<boolean>(false);
  size = input<GraphSize>('medium');
  graphType = input.required<TurnoverGraphDataType>();

  height = computed(() => this.chartHelper.getHeight(this.size()));
  title = computed(() => this.titleMapByGraphType[this.graphType()]);

  chart = computed(() => this.getChart());

  private getChart(): ChartLineChart {
    const graphType = this.graphType();
    const graphData = this.graphData();
    if (!graphType || !graphData) {
      return null;
    }
    return this.chartHelper.convertToLineChart(graphData.labels, graphData.turnover, (report) => report[graphType]);
  }

  private titleMapByGraphType: Record<TurnoverGraphDataType, string> = {
    [TurnoverGraphDataType.SALARY_COST_PERCENTAGE]: _('Salary cost percentage'),
    [TurnoverGraphDataType.COC_PERCENTAGE]: _('Salary cost percentage including CoC'),
    [TurnoverGraphDataType.SICK_LEAVE_PERCENTAGE]: _('Absence percentage'),
    [TurnoverGraphDataType.TURNOVER_PER_HOUR]: _('Turnover per hour'),
    [TurnoverGraphDataType.SALARY_PER_HOUR]: _('Salary per hour'),
  };
}
